import React, { useEffect } from "react";
import AuthHeader from "../AuthHeader/AuthHeader";
import AuthFooter from "../AuthFooter/AuthFooter";
import NotABankCustomer from "../NotABankCustomer/NotABankCustomer";
import { NavLink, Route, Switch, Redirect, Link, useLocation } from "react-router-dom";
import RegisterAsan from "../NotABankCustomer/Asan/RegisterAsan";
import SetPassword from "../NotABankCustomer/SetInfo/SetPassword";
import RegisterSima from "../NotABankCustomer/Sima/RegisterSima";
import RegistrationSuccessModal from "../../../copms/Modal/RegistrationSuccessModal";
import SetCompany from "../NotABankCustomer/SetInfo/SetCompany";

const SignUp = ({ translate, updateAppState, routeProps }) => {
  const location = useLocation();
  const { state } = location;

  return (
    <section className="ibank-sign-up header-sign-section">
      {state?.success ? <RegistrationSuccessModal translate={translate} open={true} /> : 
      <div className="header-sign-section-container">
        <AuthHeader title={translate("registration")} />
        <div className="header-sign-section-container-sign">
          <p className="header-sign-section-container-sign-type header-sign-section-container-sign-type__not-a-bank-customer header-sign-section-container-sign-type--active">
            {translate("Non-TuranBank customer")}
          </p>
          <Link
            to="/registration"
            className="header-sign-section-container-sign-type"
          >
            {translate("TuranBank customer")}
          </Link>
        </div>
        {!window.location.href.includes("/confirmation") &&
          <NotABankCustomer translate={translate} />
        }
        <Switch>
          <Redirect exact from="/sign-up/not-a-bank-customer" to="/sign-up/not-a-bank-customer/individual/asan" />
          <Redirect exact from="/sign-up/not-a-bank-customer/individual" to="/sign-up/not-a-bank-customer/individual/asan" />
          <Route exact path="/sign-up/not-a-bank-customer/*/asan" render={(routeProps) => <RegisterAsan {...routeProps} translate={translate} updateAppState={updateAppState} />} />
          <Route exact path="/sign-up/not-a-bank-customer/*/sima" render={(routeProps) => <RegisterSima {...routeProps} translate={translate} updateAppState={updateAppState} />} />
          <Route exact path="/sign-up/not-a-bank-customer/*/*/confirmation" render={(routeProps) => <SetPassword {...routeProps} translate={translate} updateAppState={updateAppState} />} />
          <Route exact path="/sign-up/not-a-bank-customer/*/*/confirmation/company" render={(routeProps) => <SetCompany {...routeProps} translate={translate} updateAppState={updateAppState} />} />
        </Switch>
        <AuthFooter
          title={translate("Already have an account?")}
          path="/login/individual/mobile"
          pathTitle={translate("Log in account")}
        />
      </div>}
    </section>
  );
};

export default SignUp;
